import { FC } from "react"
import { AttentionsDetail } from "../../../module/attentions/containers/detail"

export const AttentionsDetailPage: FC = () => <AttentionsDetail />
